module.exports = __webpack_public_path__ + "static/img/audio_pic4.e217654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/audio_pic4.png
// module id = /+jx
// module chunks = 0